<template>
  <div class="filter-sidebar-icon"
       :class="[
         {'skus-position': skuAvailability},
         {'sku-detail-position': skuDetail},
         {'skus-master-data': skusMasterData},
         {'visits-module': visitsModule},
         {'map-module': mapModule},
         {'operations-module': operationsModule},
         {'price-module-position': priceModule},
         {'team-performance-position': teamPerformancePosition}
       ]"
       @click="openFilter">
    <svg width="36"
         height="36"
         viewBox="0 0 36 36"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <rect width="36"
            height="36"
            rx="18"
            fill="#F9B723" />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.4998 17.999V24.1271C19.5297 24.3604 19.4548 24.6092 19.2823 24.7725C18.9898 25.0758 18.5174 25.0758 18.225 24.7725L16.7177 23.2094C16.5452
              23.0306 16.4703 22.7895 16.5002 22.5639V17.999H16.4778L12.1585 12.2598C11.9035 11.9254 11.9635 11.4355 12.2859 11.1711C12.4284 11.0622 12.5859 11
              12.7509 11H23.2491C23.4141 11 23.5716 11.0622 23.7141 11.1711C24.0365 11.4355 24.0965 11.9254 23.8415 12.2598L19.5222 17.999H19.4998Z"
            fill="white" />
    </svg>
  </div>
</template>

<script>
import EventBus from '@/modules/global-filters/bus';

export default {
  name: 'MobileFilterButton',
  props: {
    skuAvailability: {
      type: Boolean,
      default: false
    },
    skuDetail: {
      type: Boolean,
      default: false
    },
    skusMasterData: {
      type: Boolean,
      default: false
    },
    visitsModule: {
      type: Boolean,
      default: false
    },
    mapModule: {
      type: Boolean,
      default: false
    },
    operationsModule: {
      type: Boolean,
      default: false
    },
    priceModule: {
      type: Boolean,
      default: false
    },
    teamPerformancePosition: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openFilter() {
      EventBus.$emit('open-mobile-sidebar-filter', true);
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-sidebar-icon {
  z-index: 8;
  display: none;

  @include breakpoint(lg-max) {
    display: inherit;
  }

  &.skus-position {
    position: absolute;
    top: 8px;
    left: 5px;
  }

  &.sku-detail-position {
    position: absolute;
    top: 5px;
    left: 2px;
  }

  &.skus-master-data {
    position: absolute;
    top: 50px;
    left: 5px;
  }

  &.visits-module {
    position: absolute;
    top: 10px;
    left: 5px;
  }

  &.map-module {
    position: absolute;
    top: 5px;
    left: 10px;
  }

  &.operations-module {
    position: absolute;
    top: 72px;
    left: 5px;
  }

  &.price-module-position {
    position: absolute;
    top: 111px;
    left: 5px;

    @include breakpoint(md-s-max) {
      position: relative;
      top: 5px;
      left: 5px;
    }
  }

  &.team-performance-position {
    position: absolute;
    top: 22px;
    left: 4px;

    @include breakpoint(md-s-max) {
      position: relative;
      top: 5px;
      left: 5px;
    }
  }
}

@media all and (orientation: portrait) {
  @include breakpoint(lg-max) {
    .filter-sidebar-icon {
      display: flex;
    }
  }
}
</style>
